var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptationReserves(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_795",
    "data-name": "Groupe 795",
    transform: "translate(-177.47 -108.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_394",
    "data-name": "Groupe 394",
    transform: "translate(-1177.053 -543.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M4728.023,22433.521a10.5,10.5,0,1,1,10.5-10.5A10.512,10.512,0,0,1,4728.023,22433.521Zm-4.673-10.578-.912.912,3.547,3.541,7.73-7.73-.906-.906-6.824,6.818Z",
    transform: "translate(-3363 -21760)",
    fill: "#ffab38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptationReserves);
export default __webpack_public_path__ + "static/media/acceptation_reserves.f34dda64.svg";
export { ForwardRef as ReactComponent };